module.exports = __webpack_public_path__ + "fonts/Evogria.308d1553.ttf";